export enum CodeType {
  Unknown = 0,
  EIRcode = 1,
  PinCode = 2,
  PostalCode = 3,
  ZipCode = 4,
}
